"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_EMAIL = void 0;
exports.SUPPORT_EMAIL = 'support@faeththerapeutics.com';
